import { themeColors } from '@/config/theme/themeColors.ts';

export const borders = {
  basicBorder: `1px solid ${themeColors.gray_20}`,
  gray10Border: `1px solid ${themeColors.gray_10}`,
  gray12Border: `1px solid ${themeColors.gray_12}`,
  gray30Border: `1px solid ${themeColors.gray_30}`,
  hoverBorder: `1px solid ${themeColors.blue_65}`,
  hoverDarkBorder: `1px solid ${themeColors.darkBlue}`,
  invalidBorder: `1px solid ${themeColors.red}`,
  whiteBorder: `1px solid ${themeColors.white}`,
};
